import { takeLatest, call, put } from 'redux-saga/effects';
import { notification } from 'antd';
import {
  GET_CARBON_EMISSION,
  getCarbonEmissionSuccess,
  GET_CARBON_CONTACT,
} from '../actions';
import { getCarbonEmissionRequest, getCarbonContactRequest } from '../services';

function* getCarbonEmissionWorker() {
  try {
    const emission = yield call(getCarbonEmissionRequest);
    yield put(getCarbonEmissionSuccess(emission));
  } catch (error) {
    console.warn(error);
  }
}

function* getCarbonContactWorker() {
  try {
    const emission = yield call(getCarbonContactRequest);
    yield put(getCarbonEmissionSuccess(emission));

    notification.success({
      message: 'Courriel envoyé',
    });
  } catch (error) {
    console.warn(error);
  }
}

export function* carbonMainSaga() {
  yield takeLatest(GET_CARBON_EMISSION, getCarbonEmissionWorker);
  yield takeLatest(GET_CARBON_CONTACT, getCarbonContactWorker);
}
